import { __generator } from "tslib";
import { takeEvery, put, all } from 'redux-saga/effects';
import { dropFallbackEditorBannerFlag } from './actions';
import { dropFirstTimeFlag, FirstTimeFlag } from '../../../redux/firstTimeFlags';
function handleDropFallbackEditorBannerFlag(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(dropFirstTimeFlag({ flag: FirstTimeFlag.IsFallbackEditorNotUsed }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function fallbackEditorBannerSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(dropFallbackEditorBannerFlag, handleDropFallbackEditorBannerFlag),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map